import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    const current = document.documentElement.lang
    const other   = current === "ru" ? "en" : "ru"
    const path    = window.location.pathname
    const search  = window.location.search
    const hash    = window.location.hash

    let next
    if (path.match(/^\/(ru|en)(\/|$)/)) {
      next = path.replace(/^\/(ru|en)/, `/${other}`)
    } else if (path === "/" || path === "") {
      next = `/${other}`
    } else {
      next = `/${other}${path}`
    }

    window.location.assign(next + search + hash)
  }
}
